import { render, staticRenderFns } from "./AddedChange.vue?vue&type=template&id=2620a790&"
import script from "./AddedChange.vue?vue&type=script&lang=js&"
export * from "./AddedChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports